module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-6-3b971af434eb043127fd263f04ed13da.jpg";